import { render, staticRenderFns } from "./LinkEditor.vue?vue&type=template&id=e6870d8c&"
import script from "./LinkEditor.vue?vue&type=script&lang=ts&"
export * from "./LinkEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LinkEditor.vue?vue&type=style&index=0&id=e6870d8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports